(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaController', ZetaController);

    ZetaController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Zeta",
		"ZetaFecha",
		"ParseLinks",
		"AlertService"
		];

    function ZetaController($scope,  $filter, $state, Zeta, ZetaFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		
		vm.ixcounter = 0;
		
		vm.nombrearchivocsv=null;
		vm.nombrearchivoexcel=null;
		vm.seleccionRazonSocial = null;
		vm.seleccionAeropuerto = null;
		  
		
		vm.onChangeDate = onChangeDate;
		vm.onChangeAep = onChangeAep;
		vm.onChangeRazonSocial = onChangeRazonSocial;
		
		vm.previousMonth = previousMonth;
		vm.today = today;
		
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";//"<Todos>";
		vm.arrayComercios = null;

		vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;

		vm.listaRazonSocial = null;
		vm.seleccionRazonSocial = "<Todos>";//"<Todos>";
		vm.arrayRazonSocial = null;

		vm.listaComerciosByRazonSocial = null;
		
		vm.toDate=JSON.parse( sessionStorage.getItem( 'zetasfechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'zetasfechadesde'), dateReviver );
		
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2022, 1, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };
		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'zetasfechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('zetasfechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  ZetaFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				//
				vm.listaComercios= new Map();
				vm.listaAeropuertos= new Map();
				vm.listaRazonSocial= new Map();
				vm.listaComerciosByRazonSocial = new Map();
				
				//
				result.forEach(function(zeta){
					//estas 2 cosas son un HACK, para reusar variables para la vista!!
					
					//2 zeta.ticketsmontoventas
					
					//3 esta sera neto sin impuestos
					//zeta.ticketscantventas=zeta.ticketsmontoventas - Math.abs(zeta.ticketsmontoncredito) - Math.abs(zeta.tax1a);
					//
					//1 esto es el neto de ventas menos ncredito
					zeta.ticketsmontoncredito= zeta.ticketsmontoventas - Math.abs(zeta.ticketsmontoncredito);
					
					if(!vm.listaComercios.has(zeta.comercio)){		
						vm.listaComercios.set(zeta.comercio, zeta.aeropuerto);   
						}
					if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				
						vm.listaAeropuertos.set(zeta.aeropuerto, true);    
						}				
					if(!vm.listaRazonSocial.has(zeta.razonsocial)){		
						vm.listaRazonSocial.set(zeta.razonsocial, zeta.aeropuerto);   
						}
					if(!vm.listaComerciosByRazonSocial.has(zeta.comercio)){		
						vm.listaComerciosByRazonSocial.set(zeta.comercio, zeta.razonsocial);   
						}
					})  
				//

				vm.arrayComercios= new Array();
				vm.listaComercios.forEach(function(value, key){ vm.arrayComercios.push([key, value])});
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift(["<Todos>", ""]);

				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");

				vm.arrayRazonSocial= new Array();
				vm.listaRazonSocial.forEach(function(value, key){ vm.arrayRazonSocial.push([key, value])});
				vm.arrayRazonSocial.sort();
				vm.arrayRazonSocial.unshift(["<Todos>", ""]);
				
				vm.zetas = result;
			}
		  );
 		}
		


		/*
		function onChangeRazonSocial() {
		  vm.arrayComercios = [];
		  vm.seleccionRazonSocial = $scope.vm.seleccionRazonSocial;
		  vm.seleccionAeropuerto = $scope.vm.seleccionAeropuerto;
		  if (!seleccionRazonSocial || !seleccionRazonSocial.length || seleccionRazonSocial[0] === "<Todos>") {
			vm.listaComercios.forEach(function(value, key) {
				if (!seleccionAeropuerto || !seleccionAeropuerto.length || seleccionAeropuerto === "<Todos>") {	
			  	  vm.arrayComercios.push([key, value]);
				} else {
					if(seleccionAeropuerto === value){
						vm.arrayComercios.push([key, value]);	
					}
				}
			});
		  } else {
			vm.aepselected = null;
			vm.listaRazonSocial.forEach(function (value1, key1) {
				if (seleccionRazonSocial[0] === key1) {
				  vm.aepselected = value1;
				  vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
					if (seleccionRazonSocial[0] === value2) {
						if(!vm.arrayComercios.length){
							vm.arrayComercios.push([key2, vm.aepselected]);
						}
						else {
							for (let i = 0; i < vm.arrayComercios.length; i++) {
								if (!(vm.arrayComercios[i][0] === key2)) {
									vm.arrayComercios.push([key2, vm.aepselected]);
									break;
								}
							}
						}
					}
				  });
				}
			  });
		  }
		  vm.arrayComercios.sort();
		  vm.arrayComercios.unshift(["<Todos>", ""]);
		}
		*/
		
		/*
		function AddAllComerciosAeropuerto()
		{
			vm.listaComercios.forEach(function(value, key) {
			if (!vm.seleccionAeropuerto || !vm.seleccionAeropuerto.length || vm.seleccionAeropuerto === "<Todos>") {	
		  	  vm.arrayComercios.push([key, value]);
			} else {
				if(vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);	
				}
			}
			});
		}
		
		
		function ProcessAddAllComerciosByRazonSocial()
		{
		vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
			if (vm.seleccionRazonSocial[0] === value2) {
				if(!vm.arrayComercios.length){
					vm.arrayComercios.push([key2, vm.aepselected]);
				}
				else {
					for (let i = 0; i < vm.arrayComercios.length; i++) {
						if (!(vm.arrayComercios[i][0] === key2)) {
							vm.arrayComercios.push([key2, vm.aepselected]);
							break;
						}
					}
				}
			}
		  });
		}
		
		*/
		
		function AddAllComerciosAeropuerto()
		{
			vm.listaComercios.forEach(function(value, key) {
			if (!vm.seleccionAeropuerto || !vm.seleccionAeropuerto.length || vm.seleccionAeropuerto === "<Todos>") {	
		  	  vm.arrayComercios.push([key, value]);
			} else {
				if(vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);	
				}
			}
			});
		}
				
		//lpmqlp Javascript, si uso let i=0...son variables creadas dentro de un forEach...data
		//error ocul;to en el packing war, pero en develop anda...que hdp! 2 dias renegando..
		//este codigo quedo suboptimo!.
		function addOnlyBySameRazonSocial( key2) {
			for (vm.ixcounter = 0; vm.ixcounter < vm.arrayComercios.length; vm.ixcounter++) {
				if (vm.arrayComercios[vm.ixcounter][0] != key2) {
					vm.arrayComercios.push([key2, vm.aepselected]);
					break;
				}
			}
		}
		
		function ProcessAddAllComerciosByRazonSocial()
		{
			vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
				if (vm.seleccionRazonSocial[0] === value2) {
					if(!vm.arrayComercios.length){
						vm.arrayComercios.push([key2, vm.aepselected]);
					} else {
						addOnlyBySameRazonSocial(key2);
					}
				}
			/*
			if (vm.seleccionRazonSocial[0] === value2) {
				if(!vm.arrayComercios.length){
					vm.arrayComercios.push([key2, vm.aepselected]);
				}
				else {
					for (let i = 0; i < vm.arrayComercios.length; i++) {
						if (!(vm.arrayComercios[i][0] === key2)) {
							vm.arrayComercios.push([key2, vm.aepselected]);
							break;
						}
					}
				}
			}
			*/
		  });
		
		}
		
		function AddAllComerciosByRazonSocial()
		{
		vm.aepselected = null;
		vm.listaRazonSocial.forEach(function (value1, key1) {
			if (vm.seleccionRazonSocial[0] === key1) {
			  vm.aepselected = value1;
			  ProcessAddAllComerciosByRazonSocial();
			  }
		  });
		}
		
		
		function onChangeRazonSocial() {
		  vm.arrayComercios = [];
		  vm.seleccionRazonSocial = $scope.vm.seleccionRazonSocial;
		  vm.seleccionAeropuerto = $scope.vm.seleccionAeropuerto;
		  if (!vm.seleccionRazonSocial || !vm.seleccionRazonSocial.length || vm.seleccionRazonSocial[0] === "<Todos>") {
			  AddAllComerciosAeropuerto();
		  } else {
			  AddAllComerciosByRazonSocial();
		  }
		  vm.arrayComercios.sort();
		  vm.arrayComercios.unshift(["<Todos>", ""]);
		}
		
					
		//esto para refrescar la lista de comercios en funcion del AEP!
		function onChangeAep() {
			vm.arrayRazonSocial.splice(0,vm.arrayRazonSocial.length);
			vm.listaRazonSocial.forEach(function(value, key){ 
				if("<Todos>" === $scope.vm.seleccionAeropuerto){	
					vm.arrayRazonSocial.push([key, value]);
					}
				else if($scope.vm.seleccionAeropuerto === value){
					vm.arrayRazonSocial.push([key, value]);
					}
				}
				);
			vm.arrayRazonSocial.sort();
			vm.arrayRazonSocial.unshift(["<Todos>", ""]);
			//
			vm.arrayComercios.splice(0,vm.arrayComercios.length);
			vm.listaComercios.forEach(function(value, key){ 
				if("<Todos>" === $scope.vm.seleccionAeropuerto){	
					vm.arrayComercios.push([key, value]);
					}
				else if($scope.vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);
					}
				}
				);
			vm.arrayComercios.sort();
			vm.arrayComercios.unshift(["<Todos>", ""]); 
			}




		$scope.filtraPorRazonSocial = function (zeta) {
			if( !$scope.vm.seleccionRazonSocial ||	!$scope.vm.seleccionRazonSocial.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionRazonSocial){
				return true;
				}
			if("<Todos>" === $scope.vm.seleccionRazonSocial[0]){
				return true;
				}
			if(zeta.razonsocial === $scope.vm.seleccionRazonSocial[0]){
				return true;	
				}	
			return false;
		}

			
		$scope.filtraPorComercio = function (zeta) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio){
				return true;
				}
			if("<Todos>" === $scope.vm.seleccionComercio[0]){
				return true;
				}
			if(zeta.comercio === $scope.vm.seleccionComercio[0]){
				return true;	
				}	
			return false;
		}
				
		
		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto || !$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				return true;
				}
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				return true;	
				}
			return false;
		}
	
		//---------------------------------------------------------------------------------------------------------------------------

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
				
		
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}
		
	

		 
		//area exportacion EXCEL/CSV
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'EstadoPV',
			  headers:false, 
			  caption: {
				  title:'EstadoPV',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mydateformat = function(value) {
            //var date = new Date(value);
            //return date.toLocaleDateString();
			if (value !== "") {
                var effectiveDate = new Date(value);
                var month = effectiveDate.getMonth() + 1;
                var date = effectiveDate.getDate();
                var year = effectiveDate.getFullYear();
                return date + "-" + month + "-" + year;
            } else {
                return ""
            }
        };
		
		var dateFormat = "dd-MM-yyyy";
		var emptyColumn = "";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nomcoFecha="Fecha";
		var nomcoAeropuerto="Aeropuerto";
		var nomcoRazonSocial="RazonSocial";
		var nomcoComercio="Comercio";
		var nomcoNroTerminal="NroTerminal";
		var nomcoVentasBrutas="VentasBrutas";
		var nomcoVentasBrutasSNCRED="VentasBrutasSNCRED";
		var nomcoMetodo="ModImpresora";
		var nomcoModImpresora="ModImpresora";
		var nomcoTickets="Tickets";
		
		//Fecha 	Aeropuerto 	RazonSocial 	Comercio 	NroTerminal 	Ventas Brutas 	Ventas Brutas s/NCred 	Metodo 	ModImpresora 	

		vm.exportDataCSV = function () {
			vm.estadopvfiltrado = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto).filter($scope.filtraPorRazonSocial).filter($scope.filtraPorComercio));			
			vm.nombrearchivocsv= fechadesde + '_al_' + fechahasta;
			alasql('select * INTO CSV("EstadoPV_'+ vm.nombrearchivocsv + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?, ? \
				union all SELECT \
				mydateformat(fechaoperativa) as Fecha, aeropuerto as Aeropuerto, razonsocial as [Razon Social], \
				comercio as Comercio, ip as [Nro Terminal], ticketsmontoncredito as [Ventas Brutas],  ticketsmontoventas as [Ventas S/NCRED], ticketscantventas as Tickets, \
				metodo as Metodo, modimpresora as [Mod.Impresora] \
				FROM ?)', 
				[mystyle, nomcoFecha,nomcoAeropuerto,nomcoRazonSocial,nomcoComercio,nomcoNroTerminal,nomcoVentasBrutas,nomcoVentasBrutasSNCRED,nomcoTickets, nomcoMetodo,
				nomcoModImpresora,vm.estadopvfiltrado]);
			}
			
			
		vm.exportDataExcel = function () {
			vm.estadopvfiltrado = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto).filter($scope.filtraPorRazonSocial).filter($scope.filtraPorComercio));			
			vm.nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
			alasql('select * INTO XLSX("EstadoPV_'+ vm.nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?, ? \
				union all SELECT \
				mydateformat(fechaoperativa) as Fecha, aeropuerto as Aeropuerto, razonsocial as [Razon Social], \
				comercio as Comercio, ip as [Nro Terminal], ticketsmontoncredito as [Ventas Brutas],  ticketsmontoventas as [Ventas S/NCRED], ticketscantventas as Tickets, \
				metodo as Metodo, modimpresora as [Mod.Impresora] \
				FROM ?)', 
				[mystyle, nomcoFecha,nomcoAeropuerto,nomcoRazonSocial,nomcoComercio,nomcoNroTerminal,nomcoVentasBrutas,nomcoVentasBrutasSNCRED,nomcoTickets, nomcoMetodo,
				nomcoModImpresora,vm.estadopvfiltrado]);
		}
			
	
	}
		
})();

